module.exports = __webpack_public_path__ + "img/exportBlack.b7c30545.svg";